export interface EsfDetails {
    cartUuid: string;
    inscriptionIds: number[];
    /** traveller.id → ESF inscription id for per-participant lesson selection */
    inscriptionsByTravellerId?: Record<string, number>;
    /** traveller.id → lesson selling price (filled server-side from ESF /inscriptions) */
    pricesByTravellerId?: Record<string, number>;
    channel?: string;
    resortCode?: number;
    stayFrom?: string;
    stayTo?: string;
    intermediary?: string;
    orderId?: string;
    validatedAt?: string;
}

export const ESF_WIDGET_OPTION_KEY = 'esf-widget';

export function isEsfDetails(details: unknown): details is EsfDetails {
    if (!details || typeof details !== 'object') return false;
    const d = details as EsfDetails;
    return typeof d.cartUuid === 'string' && Array.isArray(d.inscriptionIds);
}
